module.exports = __webpack_public_path__ + "static/img/victim-kids-3.44322a2f.png";